import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import Menu from "../components/menu";

const bg = require("../../../../images/servicehero.png");

class MoveInCleaningGoldCoast extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="Move In Cleaning Gold Coast | Deep New Home Cleaning"
          description="Move in cleaning Gold Coast specialists. Deep sanitisation and full property cleaning before you settle into your new home."
          keywords="move in cleaning gold coast, new home cleaning gold coast, house sanitisation gold coast, deep home cleaning gold coast, relocation cleaning gold coast, property handover cleaning gold coast, pre move cleaning gold coast, move in house cleaning gold coast, apartment move in cleaning gold coast, unit move in cleaning gold coast, professional move in cleaners gold coast, full property cleaning gold coast, bathroom sanitisation gold coast, kitchen deep cleaning gold coast, floor mopping gold coast, carpet vacuuming gold coast, dust removal cleaning gold coast, window cleaning gold coast, eco friendly move in cleaning gold coast, affordable move in cleaning gold coast, reliable move in cleaners gold coast, same day move in cleaning gold coast, real estate move in cleaning gold coast, builders clean before move in gold coast, post renovation move in cleaning gold coast, deep property cleaning gold coast, house fresh start cleaning gold coast, residential sanitisation gold coast, new apartment cleaning gold coast, trusted move in cleaning gold coast"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">Move In Cleaning Gold Coast</h1>
                <div className="breadcrumb-row">
                  {/* Breadcrumbs can be uncommented if needed */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <Menu />
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            Move In Cleaning Services Gold Coast
                          </h4>
                          <p>
                            Moving into a new home should feel exciting and
                            fresh. Our move in cleaning Gold Coast service
                            ensures your property is thoroughly cleaned and
                            sanitised before you unpack.
                          </p>
                          <p>
                            We remove dust, dirt and bacteria left by previous
                            occupants to provide a healthy start.
                          </p>
                        </div>

                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            What Is Included in Move In Cleaning
                          </h4>
                          <h5 className="m-b10">Kitchen Deep Cleaning</h5>
                          <ul className="list-check primary">
                            <li>Cleaning inside cupboards</li>
                            <li>Appliance cleaning</li>
                            <li>Sink sanitisation</li>
                            <li>Floor mopping</li>
                          </ul>

                          <h5 className="m-b10 m-t20">Bathroom Sanitisation</h5>
                          <ul className="list-check primary">
                            <li>Shower scrubbing</li>
                            <li>Toilet disinfection</li>
                            <li>Mirror polishing</li>
                            <li>Tile cleaning</li>
                          </ul>

                          <h5 className="m-b10 m-t20">
                            Living Areas and Bedrooms
                          </h5>
                          <ul className="list-check primary">
                            <li>Vacuuming carpets</li>
                            <li>Dusting surfaces</li>
                            <li>Window cleaning</li>
                            <li>Wardrobe cleaning</li>
                          </ul>
                        </div>

                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Why Choose Professional Move In Cleaning
                          </h4>
                          <ul className="list-check primary">
                            <li>Saves time</li>
                            <li>Ensures hygiene</li>
                            <li>Provides peace of mind</li>
                            <li>Thorough and systematic cleaning</li>
                          </ul>
                        </div>

                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">Service Areas</h4>
                          <ul className="list-check primary">
                            <li>Gold Coast</li>
                            <li>Southport</li>
                            <li>Broadbeach</li>
                            <li>Surfers Paradise</li>
                          </ul>
                        </div>

                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Book Move In Cleaning Today
                          </h4>
                          <p>
                            Contact Kangaroo Shine Property Services for
                            professional move in cleaning Gold Coast.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default MoveInCleaningGoldCoast;
